module.exports = __webpack_public_path__ + "static/img/vux_logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vux_logo.png
// module id = 64
// module chunks = 15